import '../../../../3P/video-js/dist/video.js';
import '../../../../3P/jquery/jquery.min.js';
import '../../../../3P/then-promise/promise.js';
import './Shared/promise.extras.js';
import '../../../../3P/dozuki-api-js/dozuki.js';
import '../../../../3P/dozuki-api-js/wrappers/jquery.http.js';
import './embed/embed.v4.step_switcher.js';
import './embed/embed.v4.fullscreen.js';
import './embed/embed.v4.steps.js';
import './embed/embed.v4.data.js';
import './embed/embed.v4.title.js';
import './embed/embed.v4.intro.js';
import './embed/embed.v4.conclusion.js';
import './embed/embed.v4.prepare.js';
import './embed/embed.v4.zoom.js';
import './embed/embed.v4.js';
